export default __webpack_public_path__ + "static/media/empty.114f8345.png";